import { render, staticRenderFns } from "./radios.vue?vue&type=template&id=48cb1245&"
import script from "./radios.vue?vue&type=script&lang=js&"
export * from "./radios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports